import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const useStyles = makeStyles((theme) => ({
  outlinedRedButtonStyle: {
    width: "100px",
    borderRadius: 4,
    color: "#E0281D",
    borderColor: "#E0281D",
    padding: 0,
    height: "34px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },

  datePickerStyle: {
    width: "100%",
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  autoComStyle: {
    "& .MuiFormControl-root": {
      width: "100%",
      //  marginTop: 15,
      marginBottom: 5,
      "& .MuiInputLabel-outlined": {
        fontSize: 14,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 14,
    },
  },
}));

export default function EditEventDialog({
  closeDialog,
  handleDone,
  handleDeleteEvent,
  eventName,
  eventType,
  termEvents,
  desc,
  attendanceRequired,
  scheduledDate,
  parentPeriod
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    scheduledDate: "",
    eventName: "",
    delete: "",
  });
  const [selectedEventType, setSelectedEventType] = useState(eventType);
  const [eventNameEdit, setEventNameEdit] = useState(eventName);
  const [descEdit, setDescEdit] = useState(desc);
  const [attendanceRequiredEdit, setAttendanceRequiredEdit] = useState(attendanceRequired);
  const [scheduledDateEdit, setScheduledDateEdit] = useState(scheduledDate);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleScheduledDateChange = (date) => {
    setErrorMsg({ scheduledDate: "" });
    setScheduledDateEdit(date);
    if (!date)
      setErrorMsg({ scheduledDate: "Scheduled Date cannot be blank." });
  };
  const handleScheduledDateError = (error) => {
    if (error === "invalidDate")
      setErrorMsg({ scheduledDate: "Your date is not valid." });
  };

  function formatDate(dateString) {
    const options = { month: "short", day: "numeric" };
    const date = new Date(dateString);
    const dateFormatter = new Intl.DateTimeFormat("en-US", options);
    const formattedDate = dateFormatter.format(date);
    return `${formattedDate}`;
  }

  function dayFormat(dateObject) {
    if (!dateObject.$d) return dateObject;
    const date = new Date(dateObject.$d);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleSave = () => {
    if (eventNameEdit.trim() === "") {
      setErrorMsg({ eventName: "Event Name cannot be blank." });
    } else if (errorMsg["scheduledDate"] === "Your date is not valid.") {
      return;
    } else if (!scheduledDateEdit) {
      setErrorMsg({ scheduledDate: "Scheduled Date cannot be blank." });
    } else {
      setOpen(false);
      handleDone(
        eventNameEdit,
        selectedEventType,
        formatDate(scheduledDateEdit),
        dayFormat(scheduledDateEdit),
        descEdit,
        attendanceRequiredEdit
      );
    }
  };

  const handleEventNameChange = (event) => {
    if (event.target.value.trim() === "")
      setErrorMsg({ eventName: "Event Name cannot be blank." });
    else setErrorMsg({ eventName: "" });
    setEventNameEdit(event.target.value);
  };
  const handleDescChange = (event) => {
    // Limit input to 254 characters
    if (event.target.value.length <= 254) {
      setDescEdit(event.target.value);
    }
  };
  const handleDelEvent = () => {
    if (confirmDelete) handleDeleteEvent();
    else {
      setErrorMsg({
        delete:
          "Are you sure you want to delete this event? Click the Delete button again.",
      });
      setConfirmDelete(true);
    }
  };
  // const handleChangeEventTypeOptionValue = (value) => {
  //   setSelectedEventType(value);
  // };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Edit Event
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              pt={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Autocomplete
                options={termEvents.map(({ name }) => name)}
                disableClearable
                fullWidth
                value={selectedEventType}
                onChange={(e, value) => {
                  setSelectedEventType(value);
                }}
                className={classes.autoComStyle}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    //  required={true}
                    fullWidth
                    label="Event Type"
                    margin="normal"
                    name="eventType"
                    id="eventType"
                    variant="outlined"
                    {...params}
                  />
                )}
              />
            </Box>
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              required
              label="Event Name"
              margin="normal"
              name="eventName"
              variant="outlined"
              id="eventName"
              value={eventNameEdit}
              onChange={handleEventNameChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.eventName}
              </FormHelperText>
            )}
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              label="Description"
              margin="normal"
              name="Description"
              variant="outlined"
              id="Description"
              value={descEdit}
              onChange={handleDescChange}
              multiline
              rows={4}
            />
            <Typography variant="h3">
              Attendance Required?{" "}
              <Checkbox
                checked={attendanceRequiredEdit}
                onChange={(e) => setAttendanceRequiredEdit(e.target.checked)}
                id="Attendance Required?"
              />
            </Typography>
            <Box pt={3} pb={1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disablePast
                  className={classes.datePickerStyle}
                  label="Scheduled Date*"
                  id="scheduledDateEdit"
                  name="scheduledDateEdit"
                  value={dayjs(scheduledDateEdit)}
                  onError={(newError) => handleScheduledDateError(newError)}
                  onChange={handleScheduledDateChange}
                  minDate={parentPeriod && dayjs(parentPeriod.startDate)}
                  maxDate={parentPeriod && dayjs(parentPeriod.endDate)}
                />
              </LocalizationProvider>
              {errorMsg.scheduledDate && (
                <FormHelperText className={classes.errorStyle} error>
                  {errorMsg.scheduledDate}
                </FormHelperText>
              )}
            </Box>
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.delete}
              </FormHelperText>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              style={{ marginRight: 5 }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={classes.outlinedRedButtonStyle}
              variant="outlined"
              onClick={handleDelEvent}
            >
              Delete
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
